export default __webpack_public_path__ + "static/logo-full-65f59fa64cab50bded26db0fc0ccd73a.svg";